import React from 'react'
import styles from './block-nav.module.scss'
const BlockNav = () => {
  return <div className={styles.blockNav}></div>
}

export default BlockNav
